/**
 * Smartlook SDK Loader
 *
 * Dynamically loads the Smartlook SDK script and handles the queue pattern.
 * Returns a promise that resolves when the SDK is ready.
 */
export function loadSmartlookSDK(): Promise<void> {
  return new Promise((resolve, reject) => {
    // If Smartlook is already loaded and initialized, resolve immediately
    if (window.smartlook && typeof window.smartlook === 'function') {
      // Check if it's the real Smartlook function (not our queue function)
      const smartlookObj = window.smartlook as unknown as { api?: unknown[] }
      if (!smartlookObj.api) {
        // Real Smartlook is loaded
        resolve()
        return
      }
    }

    // Initialize the queue pattern (similar to Google Analytics)
    if (!window.smartlook) {
      const smartlookQueue: unknown[] = []
      const smartlookFunction = function (...args: unknown[]) {
        smartlookQueue.push(args)
      }
      // Create object with api property first, then assign to window
      const smartlookObj = smartlookFunction as unknown as { api: unknown[] }
      smartlookObj.api = smartlookQueue
      window.smartlook = smartlookObj as unknown as typeof window.smartlook
    }

    // Create and load the script
    const script = document.createElement('script')
    script.async = true
    script.type = 'text/javascript'
    script.charset = 'utf-8'
    script.src = 'https://web-sdk.smartlook.com/recorder.js'

    script.onload = () => {
      // Wait a bit for Smartlook to process the queue and replace our queue function
      setTimeout(() => {
        resolve()
      }, 200)
    }

    script.onerror = () => {
      reject(new Error('Failed to load Smartlook SDK'))
    }

    const head = document.getElementsByTagName('head')[0]
    head.appendChild(script)
  })
}
